// extracted by mini-css-extract-plugin
export default {"reactIcons":"IconsProvider__reactIcons___K2BQp"};